import { http } from "@/providers/http";
import { utils } from "@/utils/utils";

/**
 * Email campaigns (group/bulk email), staff side.
 *
 * Campaigns target either the whole audience (`ALL`) or named audience groups
 * (`GROUP`, e.g. PART_ONE_ACCEPTED). Creating one stores a campaign record and
 * returns its id; listing returns past campaigns for the Emails page.
 */
export class EmailCampaignApi {
  private static INSTANCE = new EmailCampaignApi();

  static get instance() {
    return this.INSTANCE;
  }

  /** Past campaigns, paginated. filters: { limit, offset, status?, searchText? }. */
  public getCampaigns(filters: any) {
    const filterKeys: string[] = [];
    const keys = Object.keys(filters);
    for (let i = 0; i < keys.length; i++) {
      if (!utils.emptyValues.includes(filters[keys[i]])) {
        filterKeys.push(`${keys[i]}=${filters[keys[i]]}`);
      }
    }
    const filterStr = filterKeys.join("&");
    const endPoint = `cprs/email-campaigns?${filterStr}`;
    const headers = http.getTokenHeaders();
    return http.get(endPoint, headers).then((response) => {
      return response.data;
    });
  }

  /** Audience-group catalog for the portal (values for a GROUP campaign). */
  public getGroups() {
    const endPoint = `cprs/email-campaigns/groups`;
    const headers = http.getTokenHeaders();
    return http.get(endPoint, headers).then((response) => {
      return response.data;
    });
  }

  /**
   * Create a campaign. payload:
   * { audienceType: "ALL" | "GROUP", groups?: string[], subject, bodyHtml,
   *   cc?: string[], bcc?: string[] }.
   */
  public createCampaign(payload: any) {
    const endPoint = `cprs/email-campaigns`;
    const headers = http.getTokenHeaders();
    return http.post(endPoint, headers, payload).then((response) => {
      return response;
    });
  }
}

export const emailCampaignApi = EmailCampaignApi.instance;
